export default {
    '2b-diagram3': {
        'diagram-task': 'Identify the question that the main point raises, and the grouped ideas answer.',
        'checkboxes': {
            'title': 'Question:',
            'checkbox-1': 'How?',
            'checkbox-2': 'Why?',
            'checkbox-3': 'How know?'
        },
        'elements': {
            'one': 'Most eighteenth century ideas about the cosmos were small scale',
            'two': '<span>It was only a few thousand years old</span> <span style="margin-bottom: 2px;">(Young)</span>',
            'three': '<span>It stretched only a few million miles above</span> <span style="margin-bottom: 2px;">(Small)</span>',
            'four': '<span>The stars were physically close to the earth</span> <span style="margin-bottom: 2px;">(Close)</span>',
            'five': '<span>They influenced everyday life</span> <span style="margin-bottom: 2px;">(Influential)</span>',
        }
    }
}



// WEBPACK FOOTER //
// ./client/app/components/diagrams/2/2b/diagram3/i18n/en.js